var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUganda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c82a1d",
    d: "M0 24v-4h30v4zM0 8h30v4H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 12h30v4H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7de4b",
    d: "M0 16h30v4H0zM0 4h30v4H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h30v4H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.9 11.86a8 8 0 0 0-1.46-.66c-.01-.06-.12-.64.13-.92.3-.25.3-.52.29-.57.09-.02.33-.06.34-.1a.7.7 0 0 0-.22-.41c-.45-.42-.85-.34-1.17-.12l.22.39c-.15.18-.1.32-.07.38-.1.04-.55.13-.47.25h.02c.07.03.32 0 .46-.02-.1.08-.18.27-.01.33-.29.15-.92 1.4-.24 1.85l.03-.03c.07.08.31.35.58.42l.25.24c.02.13.04.43.01.52-.54.02-1.45-.31-1.28.7l.13-.3q0 .16.11.26a1 1 0 0 1 .06-.37c0 .12.08.39.15.16 0-.4.7-.24.82-.26.04.33.09.82.07.92-.23-.04-.78.01-.8.2.2-.02.4 0 .45 0-.08.08-.24.26-.15.38.23-.25.7-.46 1.24-.37-.09-.2-.44-.22-.52-.21-.12-1.15-.17-.8.54-1-.04-.47-.58-.83.35-.6l.1.17q.02 0 .02-.03 0 .1-.05.2l.03.02a.4.4 0 0 0 .2-.3.6.6 0 0 1-.37.64l.08.06c-.1.1-.1.16.18.03-.1.11.02.13.12.06l-.12.17v.03c1.01-.25 1.03-1.93-.04-2.11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUganda);
export default __webpack_public_path__ + "static/media/uganda.d6689fcffa3b462fc6a8dbbd04787841.svg";
export { ForwardRef as ReactComponent };